// extracted by mini-css-extract-plugin
export var cdShopBackgroundCard = "shop-module--cd-shop-background-card--02106";
export var cdShopCatActive = "shop-module--cd-shop-cat-active--33cc3";
export var cdShopCatGrid = "shop-module--cd-shop-cat-grid--18c6c";
export var cdShopCats = "shop-module--cd-shop-cats--1cd79";
export var cdShopDesc = "shop-module--cd-shop-desc--79cfa";
export var cdShopFilter = "shop-module--cd-shop-filter--b5361";
export var cdShopFilterWrapper = "shop-module--cd-shop-filter-wrapper--c638c";
export var cdShopHeading = "shop-module--cd-shop-heading--cb5e2";
export var cdShopProductCard = "shop-module--cd-shop-product-card--c1856";
export var cdShopTitle = "shop-module--cd-shop-title--2015e";
export var cdShopWrapper = "shop-module--cd-shop-wrapper--58f8f";